module.exports = __webpack_public_path__ + "static/navbar1-71e167ae1b052fff782d1b0067b01b06.png";